import { InputStyleDark } from '#/shared'

export const getStepperInputStyles = (hasError: boolean) => {
	const palette = InputStyleDark
	const inputBg = palette.backgroundColor ?? 'transparent'

	return {
		...palette,
		backgroundColor: 'transparent',
		borderRadius: '15px',
		overflow: 'hidden',
		'& .MuiInputBase-input': {
			backgroundColor: inputBg,
			borderRadius: '13px',
		},
		'& .MuiOutlinedInput-notchedOutline': { borderWidth: 2 },
		'&.Mui-error .MuiOutlinedInput-notchedOutline': {
			borderColor: hasError ? '#ff2372' : 'inherit',
		},
	}
}

